import { Injectable } from '@angular/core';
import { SchedulingService } from '../../home/main/production-reports/scheduling/services/schedule/scheduling.service';
import { DialogBoxService } from './dialog-box.service';
import {
  ProductCode,
  Schedule,
} from '../../home/main/production-reports/scheduling/models/schedule.class';
import { BrickDataService } from '../widget-services/brickdata.service';
import { ValidationService } from '../form-submittion-services/validation.service';
import { FieldEditorService } from '../widget-services/field-editor.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductCodeService {
  constructor(
    private schedule: SchedulingService,
    private dbs: DialogBoxService,
    private brickDataService: BrickDataService,
    private validationService: ValidationService,
    private fieldService: FieldEditorService,
  ) {}
  searchProductCodePopup(record: any, plantId: number) {
    this.schedule.productCodeDialog(record, plantId);
  }
  addProductcode(record: any) {
    // move to schedule service
    this.brickDataService
      .get(`/schedule/productcode/data?user_pc=${record.productCode}`)
      .subscribe(
        (response: any) => {
          if (response && Array.isArray(response.message)) {
            const productCode = response.message[0];
            if (productCode) {
              const pc = new ProductCode(productCode, this.validationService);
              if (record instanceof Schedule) {
                record.size = pc.size;
                record.brick = pc.brick;
                record.attribute = pc.attribute;
                record.solids = record.checkCharsAre25();
                record.isProductcode = false;
              } else {
                record.brick = pc.brick;
                record.productCode = pc.productCode;
                record.isProductcode = false;
              }
            }
          }
        },
        (error: any) => {
          if (error.status === 404) {
            alert('Product code not found');
            if (record instanceof Schedule) {
              record.size = '';
              record.brick = '';
            }
          }
        },
      );
  }
  async openProductcodePopup() {
    const field = await this.fieldService.getFieldType('schedule/allproducts');

    if (!field) return;

    const fieldDataPromise = firstValueFrom(
      this.fieldService.loadFieldData(field),
    );

    const componentPromise =
      import('./../../home/widget/field-editor/field-editor.component');

    const [fullField, { FieldEditorComponent }] = await Promise.all([
      fieldDataPromise,
      componentPromise,
    ]);

    this.dbs.openShellDialog(
      FieldEditorComponent,
      { field: { ...fullField, showQuery: true } },
      'Edit Form Fields',
      true,
      undefined,
      'content-only-dialog',
    );
  }
}
